export default "__VITE_ASSET__6be18776__"